const paymentMethods = ['creditcard', 'PayPal', 'iDEAL', 'bitcoin']

export default paymentMethods
